import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { BaseQueryParams } from 'types/base-query-params';
import { PaginatedResponse } from 'types/dtos';
import { ResponsePlaceDto } from '../types/dtos';
import { constructQueryParams } from 'utils/query-params-builder';
import { APP_ENDPOINTS } from 'app/endpoints';

export type PlacesQueryParams = BaseQueryParams & {
    website_id?: string;
    ids?: string;
};

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.query<PaginatedResponse<ResponsePlaceDto>, PlacesQueryParams>({
        async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
            const placesResponse = await fetchWithBQ(constructQueryParams(APP_ENDPOINTS.PLACES, _arg));

            if (placesResponse.error) {
                return { error: placesResponse.error };
            }

            const places = placesResponse.data as PaginatedResponse<ResponsePlaceDto>;

            return {
                data: places,
            };
        },
        providesTags: [{ type: 'places', id: 'GET' }],
    });
